import "./edit-util-activity-type.scss";

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormUtilActivityType from "../form-util-activity-type/form-util-activity-type";
import { useEditUtilActivityType } from "./edit-util-activity-type.hook";

export function EditUtilActivityType() {
  const {
    utilActivityTypeData,
    isLoading,
    utilActivityTypeError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditUtilActivityType();

  const title = utilActivityTypeData?.name ? (
    <h1>{utilActivityTypeData?.name}</h1>
  ) : (
    <h1>Edit Activity Type</h1>
  );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormUtilActivityType />
      </section>
    </div>
  );

  return (
    <div id="EditUtilActivityType" className="util-activity-type">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {utilActivityTypeError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditUtilActivityType;
